import {Component, Input, OnInit} from '@angular/core';
import {
  InstalmentPlanResponse,
  MatchedPlans,
  MatchResponse
} from "../../../interfaces/card/responses/InstalmentPlanResponse";
import {Validators} from "@angular/forms";
import {ThemePalette} from "@angular/material/core";
import {Router} from "@angular/router";
import {PaymentMethodsCard, PaymentMethodsOther} from "../../../interfaces/payment-methods";
import {MaskedData} from "../../../interfaces/visa-src/MaskedData";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {InitiateResponseCard} from "../../../interfaces/card/responses/InitiateResponseCard";
import {HttpErrorResponse} from "@angular/common/http";
import {InitiateRequestCard} from "../../../interfaces/card/requests/InitiateRequestCard";

@Component({
  selector: 'app-instalment',
  templateUrl: './instalment.component.html',
  styleUrls: ['./instalment.component.scss']
})
export class InstalmentComponent implements OnInit {
  isExpanded: boolean  = false;
  isAccepted: boolean = false;
  addCardState = true;
  mobile = false;
  instalmentPlanResponse: InstalmentPlanResponse;
  loading = false;
  paymentConfirm = false;
  cardExpiryMonthOpt;
  cardExpiryYearOpt;
  headerColor = '';
  color: ThemePalette = 'accent';
  diameterColour = 22;
  diameterContinue = 26;
  transactionCancelled = false;
  navigated;
  matchResponse: MatchResponse;
  plans: MatchedPlans[];
  public maskedDataObj: MaskedData;
  selected: MatchedPlans;
  terms: string;
  hashCard: string;
  initiateRequestCard: InitiateRequestCard;
  activeCard;


  constructor(    private router: Router,
                  private breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });
  }

  ngOnInit(): void {
    this.headerColor = (document.getElementsByClassName('header-container')[0] as HTMLElement).style.backgroundColor;
    this.initiateRequestCard = JSON.parse(sessionStorage.getItem('request'))
    if (this.initiateRequestCard.cardNumber != null && this.initiateRequestCard.cardNumber != undefined) {
      this.hashCard = '***** ' + this.initiateRequestCard.cardNumber.slice(-4);
    } else {
      (JSON.parse(sessionStorage.getItem('selectedCard')) as PaymentMethodsCard) !== null
        ?
        (JSON.parse(sessionStorage.getItem('selectedCard')) as PaymentMethodsCard).cardToken !== null
          ?
          this.activeCard = (JSON.parse(sessionStorage.getItem('selectedCard')))
          :
          this.activeCard = false
        :
        this.activeCard = false;
      this.hashCard = '***** ' + this.activeCard.cardNumber.slice(-4)
    }

    this.matchResponse = JSON.parse(sessionStorage.getItem('instalment')).matchResponse
    this.plans = [{
      "costInfo": {
        "currency": "ZAR",
        "feeInfo": [
          {
            "ratePercentage": 0,
            "type": "CONSUMER",
            "flatFee": 0
          }
        ],
        "firstInstallment": {
          "amount": this.matchResponse.transactionAmount,
          "installmentFee": 0,
          "upfrontFee": 0
        },
        "lastInstallment": {
          "amount": 0,
          "installmentFee": 0
        },
        "totalFees": 0,
        "totalPlanCost": this.matchResponse.transactionAmount,
        "totalRecurringFees": 0,
        "totalUpfrontFees": 0,
        "annualPercentageRate": 0
      },
      "installmentFrequency": "One Time Payment",
      "name": "Straight",
      "numberOfInstallments": 1,
      "termsAndConditions": [
        {
          "text": "Once of payment.",
          "version": 1,
          "languageCode": "eng",
          "url": ""
        }
      ],
      "promotionInfo": null,
      "type": "ISSUER_DEFAULT",
      "vPlanIDRef": "",
      "vPlanID": "straight"
    }];

    let plansLoaded = sessionStorage.getItem('plansLoaded')
    if (plansLoaded === 'true') {
      this.plans = this.matchResponse.matchedPlans;
    } else {
      this.plans = [...this.plans, ...this.matchResponse.matchedPlans];
      let instalment = JSON.parse(sessionStorage.getItem('instalment'));
      instalment.matchResponse.matchedPlans = this.plans;
      sessionStorage.setItem('instalment', JSON.stringify(instalment));
      plansLoaded = 'true';
      sessionStorage.setItem('plansLoaded', plansLoaded)
    }
    if (this.plans.length > 0) {
      this.selected = this.plans[0];
    }
  }

  cancelTransaction() {
    this.navigated = true;
    this.transactionCancelled = true;
    this.router.navigate(['transaction-status/userCancelled']);
  }

  setSelected(plan: MatchedPlans) {
    this.selected = plan;
    if (plan.vPlanID !== 'straight'){
      this.terms = plan.termsAndConditions[0].text;
    } else {
      this.terms = null;
    }

  }

  continueButton() {
    this.loading = true;

    this.router.navigate(
      [`virtual/card/confirm-selection/${this.selected.vPlanID}`]).then(() => {
      this.loading = false;
    });
  }
  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }
}
